(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
(function () {
  var galleries = new WeakMap();

  function initialise(container) {
    if (galleries.has(container)) return;
    var stage = container.querySelector('.ug-product-gallery__stage');
    var wrappers = Array.from(stage.querySelectorAll('.product-single__featured-image-wrapper'));
    var thumbnails = Array.from(container.querySelectorAll('.product-single__thumbnail'));
    var slider = container.querySelector('.product-thumbs-slider');
    if (wrappers.length < 2 || !slider) return;
    var track = slider.querySelector('.product-thumbs-slider__track');
    var thumbPrev = slider.querySelector('.product-thumbs-slider__arrow--prev');
    var thumbNext = slider.querySelector('.product-thumbs-slider__arrow--next');
    var previous = stage.querySelector('[data-gallery-previous]');
    var next = stage.querySelector('[data-gallery-next]');
    var status = container.querySelector('[data-gallery-status]');
    var gesture = null;
    var suppressClickUntil = 0;
    var activeId = null;
    var listeners = [];

    function on(target, type, listener, options) {
      target.addEventListener(type, listener, options);
      listeners.push(function () { target.removeEventListener(type, listener, options); });
    }

    function scrollBehaviour() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }

    function updateArrows() {
      var max = track.scrollWidth - track.clientWidth;
      thumbPrev.disabled = track.scrollLeft <= 1;
      thumbNext.disabled = track.scrollLeft >= max - 1;
      slider.classList.toggle('no-overflow', max <= 1);
    }

    function scrollToLeft(left) {
      if (typeof track.scrollTo === 'function') {
        try {
          track.scrollTo({ left: left, behavior: scrollBehaviour() });
          return;
        } catch (error) {}
      }
      track.scrollLeft = left;
    }

    function scrollThumbs(direction) {
      var item = track.querySelector('.product-thumbs-slider__item');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var step = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
      scrollToLeft(track.scrollLeft + direction * step);
    }

    function currentIndex() {
      return wrappers.findIndex(function (wrapper) { return !wrapper.classList.contains('hidden'); });
    }

    function sync() {
      var index = currentIndex();
      if (index < 0) return;
      var wrapper = wrappers[index];
      var id = wrapper.getAttribute('data-image-id');
      if (activeId === id) return;
      var hadActiveImage = activeId !== null;
      activeId = id;
      thumbnails.forEach(function (thumbnail) {
        var selected = thumbnail.getAttribute('data-image-id') === id;
        thumbnail.classList.toggle('is-active', selected);
        if (selected) {
          thumbnail.setAttribute('aria-current', 'true');
          var item = thumbnail.parentElement;
          var left = item.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
          var right = left + item.offsetWidth;
          if (left < track.scrollLeft || right > track.scrollLeft + track.clientWidth) {
            scrollToLeft(left < track.scrollLeft ? left : right - track.clientWidth);
          }
        } else {
          thumbnail.removeAttribute('aria-current');
        }
      });
      if (hadActiveImage) status.textContent = wrapper.getAttribute('data-gallery-announcement');
    }

    function move(direction) {
      var index = currentIndex();
      if (index < 0) return;
      var target = wrappers[(index + direction + wrappers.length) % wrappers.length];
      var id = target.getAttribute('data-image-id');
      var thumbnail = thumbnails.find(function (item) { return item.getAttribute('data-image-id') === id; });
      if (thumbnail) thumbnail.click();
      sync();
    }

    on(previous, 'click', function () { move(-1); });
    on(next, 'click', function () { move(1); });
    on(thumbPrev, 'click', function () { scrollThumbs(-1); });
    on(thumbNext, 'click', function () { scrollThumbs(1); });
    on(track, 'scroll', updateArrows, { passive: true });
    on(stage, 'keydown', function (event) {
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      }
    });
    on(stage, 'pointerdown', function (event) {
      if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
      if (!event.isPrimary) { gesture = null; return; }
      if (event.target.closest('button, a')) return;
      suppressClickUntil = 0;
      gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
    }, { passive: true });
    on(stage, 'pointermove', function (event) {
      if (!gesture || event.pointerId !== gesture.id) return;
      var dx = Math.abs(event.clientX - gesture.x);
      var dy = Math.abs(event.clientY - gesture.y);
      if (dy > 12 && dy > dx) gesture = null;
    }, { passive: true });
    on(stage, 'pointerup', function (event) {
      if (!gesture || event.pointerId !== gesture.id) return;
      var dx = event.clientX - gesture.x;
      var dy = event.clientY - gesture.y;
      gesture = null;
      if (Math.abs(dx) >= 48 && Math.abs(dx) > Math.abs(dy) * 1.4) {
        suppressClickUntil = Date.now() + 700;
        move(dx < 0 ? 1 : -1);
      }
    }, { passive: true });
    on(stage, 'pointercancel', function () { gesture = null; }, { passive: true });
    on(stage, 'click', function (event) {
      if (Date.now() < suppressClickUntil && !event.target.closest('button')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, { capture: true });

    var observer = new MutationObserver(sync);
    wrappers.forEach(function (wrapper) { observer.observe(wrapper, { attributes: true, attributeFilter: ['class'] }); });
    var resizeObserver = null;
    if (typeof ResizeObserver === 'function') {
      resizeObserver = new ResizeObserver(updateArrows);
      resizeObserver.observe(track);
    }
    on(window, 'resize', updateArrows);
    on(window, 'pageshow', sync);
    sync();
    updateArrows();
    previous.hidden = false;
    next.hidden = false;
    stage.setAttribute('data-gallery-ready', '');
    galleries.set(container, function () {
      listeners.forEach(function (remove) { remove(); });
      observer.disconnect();
      if (resizeObserver) resizeObserver.disconnect();
      galleries.delete(container);
    });
  }

  function initialiseWithin(root) {
    root.querySelectorAll('[data-ug-product-gallery]').forEach(initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialiseWithin(document); }, { once: true });
  } else {
    initialiseWithin(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initialiseWithin(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-ug-product-gallery]').forEach(function (container) {
      var cleanup = galleries.get(container);
      if (cleanup) cleanup();
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
